import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'get'

export default class OspreyMessagesGetById extends BaseAction {
    constructor(dataKey, onError) {
        const id = '12f1b274-9eea-47fa-9e16-7f62cba78b11'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    getById(messageId, contextOrn, fetchLatest = false) {
        this.path = `/${resource}/${messageId}?X-Context-Orn=${contextOrn}`
        this.params = {
            fetchLatest
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-get-by-id.js